/* Ornamint collection page (v3.4): filter / sort panels, mobile bottom sheet, "View N more pieces", spotlight video.
   Without JS everything still works: the panels are <details>, the bar is a GET form with an apply button, and
   "View N more pieces" is a normal link to the next page. */
(function () {
  'use strict';
  var d = document, html = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 749px)');
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function init(root) {
    if (root.__ornInit) return;
    root.__ornInit = true;
    root.classList.add('is-js');
    var form = root.querySelector('[data-orn-filters]');
    var pills = [].slice.call(root.querySelectorAll('[data-orn-pill]'));
    var live = root.querySelector('[data-orn-live]');
    var openPill = function () { return pills.filter(function (p) { return p.open; })[0]; };

    // empty price boxes stay out of the URL
    var submit = function () {
      [].forEach.call(form.querySelectorAll('input[type=number]'), function (i) { if (i.value === '') i.disabled = true; });
      form.submit();
    };
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });

    // one panel at a time; on phones the open panel is a bottom-sheet dialog
    pills.forEach(function (p) {
      p.addEventListener('toggle', function () {
        if (p.open) {
          pills.forEach(function (o) { if (o !== p) o.open = false; });
          if (mobile.matches) sheet(p, true);
        } else if (p.__sheet) sheet(p, false);
      });
    });
    function sheet(p, on) {
      var panel = p.querySelector('[data-orn-panel]');
      p.__sheet = on;
      form.classList.toggle('is-sheet', on);
      html.classList.toggle('orn-coll-lock', on);
      if (on) {
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
        setTimeout(function () { var f = panel.querySelector('input:not([disabled]), button'); if (f) f.focus(); }, 60);
      } else {
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
      }
    }
    function close(p, refocus) { p.open = false; if (refocus) p.querySelector('summary').focus(); }

    root.addEventListener('click', function (e) {
      var c = e.target.closest('[data-orn-close]');
      if (c) { e.preventDefault(); close(c.closest('[data-orn-pill]'), true); }
    });
    // outside click / the sheet's backdrop (the open <details> itself) closes
    d.addEventListener('click', function (e) {
      var p = openPill();
      if (p && (!p.contains(e.target) || e.target === p)) close(p, false);
    });
    d.addEventListener('keydown', function (e) {
      var p = openPill();
      if (!p) return;
      if (e.key === 'Escape') { e.preventDefault(); close(p, true); return; }
      if (e.key === 'Tab' && p.__sheet) { // focus trap inside the sheet
        var f = [].slice.call(p.querySelectorAll(FOCUSABLE)).filter(function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    mobile.addEventListener && mobile.addEventListener('change', function () { var p = openPill(); if (p) close(p, false); });

    // desktop: list filters and sort apply on change (price waits for its Apply button); phones: "Show results"
    form.addEventListener('change', function (e) {
      if (mobile.matches || e.target.type === 'number') return;
      submit();
    });

    // "View N more pieces": next page through the Section Rendering API, appended in place
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-orn-more]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      if (a.getAttribute('aria-busy') === 'true') return;
      a.setAttribute('aria-busy', 'true');
      var url = new URL(a.href, location.href);
      url.searchParams.set('section_id', root.getAttribute('data-section-id'));
      fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var grid = root.querySelector('[data-orn-grid]');
          var items = [].slice.call(doc.querySelectorAll('[data-orn-grid] > li'));
          items.forEach(function (li) { if (!reduce) li.classList.add('is-new'); li.setAttribute('data-orn-appended', ''); grid.appendChild(li); });
          var wrap = root.querySelector('[data-orn-more-wrap]'), next = doc.querySelector('[data-orn-more-wrap]');
          if (next) wrap.replaceWith(next); else wrap.remove();
          label(grid);
          if (live) live.textContent = items.length + ' more pieces shown.';
          var link = items[0] && items[0].querySelector('a[href]');
          if (link) link.focus({ preventScroll: true });
        })
        .catch(function () { location.href = a.href; }); // fall back to the normal next page
    });
    // cards added by "View more" are not wired by the theme: their quick view opens the product page instead
    root.addEventListener('click', function (e) {
      var q = e.target.closest('[data-orn-appended] [data-quick-shop-trigger="quick-view"]');
      if (!q) return;
      e.preventDefault();
      if (q.dataset.productUrl) location.href = q.dataset.productUrl;
    }, true);

    // category strip arrows (desktop)
    var track = root.querySelector('[data-orn-cats]');
    // start the strip at the current category when it would be off-screen (a scroll inside the strip, no layout shift)
    var cur = track && track.querySelector('.is-current');
    if (cur) {
      var li = cur.parentNode, pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      if (li.offsetLeft + li.offsetWidth > track.clientWidth) track.scrollLeft = li.offsetLeft - pad;
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-orn-cats-nav]');
      if (!b || !track) return;
      track.scrollBy({ left: 560 * +b.getAttribute('data-orn-cats-nav'), behavior: reduce ? 'auto' : 'smooth' });
    });

    // card hover bar: "Add to bag · ₹price" (single-variant quick add; products with options keep "Choose options")
    label(root);

    // spotlight video: inserted when the card nears the screen, plays only while visible; never with reduced motion
    var spot = root.querySelector('[data-orn-spot]');
    var tpl = spot && spot.querySelector('template[data-orn-spot-video]');
    if (tpl && !reduce && 'IntersectionObserver' in window) {
      var video = null;
      new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting && !video) {
            var frag = tpl.content.cloneNode(true);
            video = frag.querySelector('video');
            if (!video) return;
            video.muted = true; video.setAttribute('aria-hidden', 'true');
            tpl.parentNode.insertBefore(frag, tpl);
          }
          if (video) { if (en.isIntersecting) { var pr = video.play(); if (pr && pr.catch) pr.catch(function () {}); } else video.pause(); }
        });
      }, { rootMargin: '200px 0px' }).observe(spot);
    }
  }

  function label(scope) {
    [].forEach.call(scope.querySelectorAll('.orn-coll__item .product-item__hover-action-wrap [data-quick-shop-trigger="quick-add"] > span:first-child'), function (s) {
      if (s.__ornLabel) return;
      var li = s.closest('.orn-coll__item'), p = li && li.querySelector('.orn-card-price__now');
      var price = p ? p.textContent.replace(/\s+/g, ' ').trim() : '';
      s.textContent = 'Add to bag' + (price ? ' · ' + price : '');
      s.__ornLabel = true;
    });
  }

  function boot() { [].forEach.call(d.querySelectorAll('[data-orn-coll]'), init); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  d.addEventListener('shopify:section:load', boot);
})();
